export default __webpack_public_path__ + "static/media/press1.a39d34f5.png";